<header [class.home-page]="isHomePage" [class.banamex-registration]="isBanamexRegistration">
  @if (!isBanamexRegistration) {
    <div class="logo" (click)="goToHome()" style="cursor: pointer;">
      <img src="assets/logos/cliente-a.png" alt="Logo del cliente" />
    </div>
  }
  
  @if (isBanamexRegistration) {
    <div class="back-navigation">
      <button class="back-button" (click)="goBack()">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      <h1 class="page-title">{{ pageTitle }}</h1>
    </div>
  }
</header>
